
const blocklyHome = {
  state: () => ({
    Train: {},
    createBy:'',
    scoreHandle: false,
    trainingBlockList:sessionStorage.trainingBlockList?JSON.parse(sessionStorage.trainingBlockList):[],
    rightSideVal: "guideBook", //控制右侧显示运行区还是实训指导书模块
    curriculumId: null, //课程id
    studentId: null,
    codeText: "", //原始的积木文本
    homeWorkStatus: false, //是否发布作业;
    hasRunSuccess: null //表示积木代码是否运行成功
  }),
  getters: {
    Train: state => {
      return state.Train;
    },
    trainingBlockList: state => {
      return state.trainingBlockList;
    },
    createBy: state => {
      return state.createBy;
    },
    scoreHandle: state => {
      return state.scoreHandle;
    },
    curriculumId: state => {
      return state.curriculumId;
    },
    studentId: state => {
      return state.studentId;
    },
    hasRunSuccess: state => {
      return state.hasRunSuccess;
    },
    homeWorkStatus: state => {
      return state.homeWorkStatus;
    }
  },
  mutations: {
    setTrainingBlockList(state, val){
      state.trainingBlockList = val
      sessionStorage.trainingBlockList =JSON.stringify(val)
    }
  } //mutations end
};

export default blocklyHome;
